var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56673 11.4999L3.42965 11.5C2.78531 11.4982 2.16785 11.2343 1.71223 10.7658C1.25662 10.2974 0.999896 9.66256 0.998184 9.00007C1.00003 8.33764 1.25679 7.70287 1.71238 7.23445C2.16797 6.76604 2.78535 6.50204 3.42965 6.50015L8.56673 6.5C9.21099 6.50203 9.82829 6.76606 10.2839 7.23445C10.7394 7.70284 10.9962 8.33753 10.9982 8.99993C10.9964 9.66236 10.7396 10.2971 10.284 10.7655C9.82841 11.234 9.21103 11.498 8.56673 11.4999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56673 5.49985L3.42965 5.5C2.78531 5.49824 2.16785 5.23429 1.71223 4.76585C1.25662 4.2974 0.999896 3.66256 0.998184 3.00007C1.00003 2.33764 1.25679 1.70287 1.71238 1.23445C2.16797 0.766036 2.78535 0.502043 3.42965 0.500149L8.56673 0.5C9.21099 0.502029 9.82829 0.766065 10.2839 1.23445C10.7394 1.70284 10.9962 2.33753 10.9982 2.99993C10.9964 3.66236 10.7396 4.29713 10.284 4.76555C9.82841 5.23396 9.21103 5.49796 8.56673 5.49985Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4982 10.5C9.32663 10.5 9.9982 9.82843 9.9982 9C9.9982 8.17157 9.32663 7.5 8.4982 7.5C7.66977 7.5 6.9982 8.17157 6.9982 9C6.9982 9.82843 7.66977 10.5 8.4982 10.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4982 4.5C4.32663 4.5 4.9982 3.82843 4.9982 3C4.9982 2.17157 4.32663 1.5 3.4982 1.5C2.66977 1.5 1.9982 2.17157 1.9982 3C1.9982 3.82843 2.66977 4.5 3.4982 4.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggles);
export default __webpack_public_path__ + "static/media/toggles.781fcbda.svg";
export { ForwardRef as ReactComponent };